import type { ReactNode } from 'react';

type Props = {
  label: string;
  value: ReactNode;
  icon?: string;
  iconBg?: string;
  iconColor?: string;
  delta?: string;
  deltaUp?: boolean;
  deltaLabel?: string;
};

export function StatCard({
  label, value,
  icon = 'ti-chart-bar',
  iconBg = 'var(--accent-dim)',
  iconColor = 'var(--accent)',
  delta, deltaUp = true, deltaLabel,
}: Props) {
  return (
    <div className="stat-card">
      <div className="stat-header">
        <div className="stat-icon" style={{ background: iconBg, color: iconColor }}>
          <i className={`ti ${icon}`} style={{ fontSize: 18 }} />
        </div>
        {delta && (
          <div className={`stat-delta ${deltaUp ? 'up' : 'down'}`}>
            <i className={`ti ${deltaUp ? 'ti-trending-up' : 'ti-trending-down'}`} style={{ fontSize: 12 }} />
            {delta}
          </div>
        )}
      </div>
      <div>
        <div className="stat-value">{value}</div>
        <div className="stat-label">{label}</div>
        {deltaLabel && <div style={{ fontSize: 11, color: 'var(--text-dim)', marginTop: 2 }}>{deltaLabel}</div>}
      </div>
    </div>
  );
}
